const translations = {
  "en": {
    "Add manually": "Add manually",
    "Can't find your account?": "Can't find your account?",
    "Close": "Close",
    "Connect others": "Connect others",
    "Go back": "Go back",
    "Over 12,000 institutions supported": "Over 12,000 institutions supported",
    "Popular Institutions": "Popular Institutions",
    "Start with where you invest": "Start with where you invest",
    "You came in worried about your portfolio. Link it and I read the real holdings instead of guessing.": "You came in worried about your portfolio. Link it and I read the real holdings instead of guessing."
  },
  "zh-tw": {
    "Add manually": "手動新增",
    "Can't find your account?": "找不到你的帳號？",
    "Close": "關閉",
    "Connect others": "連結其他機構",
    "Go back": "返回",
    "Over 12,000 institutions supported": "支援超過 12,000 家機構",
    "Popular Institutions": "知名機構",
    "Start with where you invest": "從你投資的地方開始",
    "You came in worried about your portfolio. Link it and I read the real holdings instead of guessing.": "你來時正為投資組合感到擔憂。連結後，我將直接讀取實際持倉，而非猜測。"
  }
};

export default translations;
